import LoginBackground from "./LoginBackground.js";

export default LoginBackground;
